import axios from 'axios';
import { ENDPOINT } from '../utils/Endpoints';
import notify from './notificationService';

export interface CallbackData {
    name: string;
    mobile: string;
    email: string;
    message: string;
    page_url:string;
}

const API_BASE_URL = `${ENDPOINT}/callback`; // Replace with your backend API base URL

class CallbackService {
    static async sendCallback(data: CallbackData): Promise<void> {
        try {
            const response = await axios.post(`${API_BASE_URL}`, data, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            if(response.status===200 || response.status===202)
                {
            notify.success('Request submitted successfully:!', {
                position: 'top-right',
                autoClose: 2000,
              });
            }
        } catch (error) {
            notify.error(`Error submitting request! ${error}`, {
                position: 'top-right',
                autoClose: 2000,
              });
            throw new Error('Failed to submit  inquiry');
        }
    }
}

export default CallbackService;
